import logEvent from "../tracking/amplitude/log-event"
import { isMobile } from "../utils/breakpoints"

const SIMULATE_FAILURE = false

const observeAds = () => {
  const targetNodes = document.querySelectorAll(".ad-container")

  const callback = function (mutationList) {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes" && mutation.attributeName === "data-ad-status") {
        const adStatus = mutation.target.dataset.adStatus
        if (adStatus === "unfilled") {
          logEvent("ad_unfilled")
          $(mutation.target).hide()
        }
      }
    }
  }

  const observer = new MutationObserver(callback)

  targetNodes.forEach((targetNode) => observer.observe(targetNode, { attributes: true }))
}

const getFakeAd = (id) => {
  const random = Math.random()

  switch (id) {
    case "above-player-ad":
    case "below-player-ad":
      if (isMobile()) {
        return "<img src='/images/fake-ad-wide-mobile.png'/>"
      }

      return "<img src='/images/fake-ad-wide.png'/>"

    case "right-rail-ad":
      if (random > 0.5) {
        return "<img src='/images/fake-ad-sidebar.png'/>"
      } else {
        return "<img style='width:200px;height:200px;' src='/images/fake-ad-sidebar.png'/>"
      }
    case "below-fold-ad":
      if (random > 0.33) {
        return "<img src='/images/fake-ad-sidebar.png'/>"
      } else if (random > 0.66) {
        return "<img src='/images/fake-ad-wide.png'/>"
      } else {
        return "<img style='width:200px;height:200px;' src='/images/fake-ad-sidebar.png'/>"
      }
    default:
      return ""
  }
}

export const loadFakeAds = () => {
  const targetNodes = document.querySelectorAll(".ad-container")

  targetNodes.forEach((targetNode) => {
    const image = getFakeAd(targetNode.id)

    setTimeout(() => {
      const random = Math.random()
      if (random > 0.1 || !SIMULATE_FAILURE) {
        $(targetNode).append(image)
        $(targetNode).attr("data-ad-status", "filled")
      } else {
        $(targetNode).attr("data-ad-status", "unfilled")
      }
    }, 500)
  })
}

observeAds()
loadFakeAds()
